module.exports = __webpack_public_path__ + "static/img/xxstlsyg.2bb2995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xxstlsyg.png
// module id = lVEh
// module chunks = 1